import {
  Box,
  Button,
  Switch,
  Typography,
} from "@mui/material";
import { withStyles } from "@material-ui/styles";


export const StyledSettingsContainer = withStyles((theme) => ({
  root: {
    height: '80px',
    borderRadius: 3,
    color: 'white',
    display: "flex",
    // flexDirection: "column",
    // overflow: "auto",
    '&::-webkit-scrollbar': {
      width: '0.2em',
    },
    '&::-webkit-scrollbar-track': {
      boxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
      webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)'
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: 'slategrey',
    },
  },
}))(Box);

export const StyledTabContainer = withStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    color: 'white',
    overflow: 'hidden',
  },
}))(Box);

export const StyledTableWrapper = withStyles(() => ({
  root: {
    flexGrow: 1,
    maxHeight: 'calc(100vh - 150px)',
    overflow: 'hidden',
  },
}))(Box);

export const StyledSwitch = withStyles((theme) => ({
  root: {
    padding: 8,
    '& .MuiSwitch-switchBase': {
      color: '#FBFF39',
      '&.Mui-checked': {
        '& + .MuiSwitch-track': {
          backgroundColor: '#FBFF39'
        },
        '& .MuiSwitch-thumb': {
          boxShadow: 'none',
          width: 16,
          height: 16,
          margin: 2,
          color: '#FBFF39'
        },
      },
      '& + .MuiSwitch-track': {
        backgroundColor: 'grey'
      },
    },
    '& .MuiSwitch-track': {
      borderRadius: 22 / 2,
      '&:before, &:after': {
        content: '""',
        position: 'absolute',
        top: '50%',
        transform: 'translateY(-50%)',
        width: 16,
        height: 16,
      },

      '&:before': {
        backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 24 24"><path fill="${encodeURIComponent(
          '#FFFFFF',
        )}" d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z"/></svg>')`,
        left: 12,
      },
      '&:after': {
        backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 24 24"><path fill="${encodeURIComponent(
          '#FFFFFF',
        )}" d="M19,13H5V11H19V13Z" /></svg>')`,
        right: 12,
      },
    },
    '& .MuiSwitch-thumb': {
      boxShadow: 'none',
      width: 16,
      height: 16,
      margin: 2,
      color: '#FFFFFF'
    },
  }
}))(Switch);

export const StyledButton = withStyles((theme) => ({
  root: {
    color: theme.palette.common.white,
    fontFamily: 'Inter',
    fontSize: '14px',
    borderRadius: '6px',
    padding: '10px 18px',
    backgroundColor: '#005CCE',
    whiteSpace: 'nowrap',
    [theme.breakpoints.up('sm')]: {
      minWidth: '300px'
    },
  }
}))(Button);

export const SubHeaderText = withStyles((theme) => ({
  root: {
    textAlign: 'center',
    fontFamily: 'Inter',
    fontSize: '18px',
    fontStyle: 'normal',
    fontWeight: 700,
    lineHeight: '140%',
  }
}))(Typography);

export const BodyText = withStyles((theme) => ({
  root: {
    color: theme.palette.common.white,
    fontFamily: 'Inter',
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: 'normal',
  }
}))(Typography);